import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss'
import {BiX} from "react-icons/bi";

const Index = (props) => (
    <div
        key={props.key}
        className={`rd-select-box-wrapper ${props.type} ${props.isActive ? 'active' : ''}`}
        onClick={props.onClick}>
        <div className={`rd-select-box ${props.isActive ? 'active' : 'inactive'}`}>
            <div className={'active-box'}/>
        </div>
        <div className={'rd-text'}>
            {props.text}
        </div>


    </div>

);

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
